/*=============================================
 * Table of content - Blog: Blog
-----------------------------------------------
    1. Recent post
    2. Newsletter
    3. Hide modal thanks
==============================================*/



// ===========================
// 1. Recent post
// ===========================
jQuery('.popular-posts__wrapper').slick({
    slidesToShow: 3,
    dots:false,
    slidesToScroll: 1,
    prevArrow: '<div class="popular-posts__prev">←</div>',
    nextArrow: '<div class="popular-posts__next">→</div>',
    responsive: [{
        breakpoint: 998,
        settings: {
            slidesToShow: 2,
            dots:true,
        }
    }, {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            dots:true,
        }
    }]
});


// ===========================
// 2. Newsletter
// ===========================
var showNewsletter = true;
var isFormLoad = false;
var isSingle = isSingle;

$(window).on("scroll", function () {
    if(!isFormLoad && isSingle){
        var jAjaxOriginalCacheSetup = $.ajaxSetup()['cache'];        
        $.ajaxSetup({cache: true});        
        $.getScript( "//lp.activtrak.com/js/forms2/js/forms2.min.js",function(){
            if(typeof jAjaxOriginalCacheSetup !== 'undefined'){
                $.ajaxSetup({cache: jAjaxOriginalCacheSetup});
            }else{
                delete $.ajaxSetup().cache;
            }                        
        });
        isFormLoad = true;    
    }
    if (Cookie.get('showNewsletter') != 'false') {
        if ($(window).scrollTop() > 400) $('.newsletter').addClass('is-active');
        else $('.newsletter').removeClass('is-active');
    }
});

$('.newsletter__close').on("click", function () {
    var newsletterHeight = $('.newsletter.is-active').css('height');
    $('.newsletter').css('bottom', '-' + newsletterHeight);
    $('.newsletter').removeClass('is-active');
    Cookie.set('showNewsletter', false);
    showNewsletter = Cookie.get('showNewsletter');
});


// ======================
// 3. Hide modal thanks
// ======================
$(window).on("click", function (e) {
    if ( e.target.classList.contains('popup-subscribe') || e.target.className == 'card-popup-subscribe__close' || e.target.className == 'btn is-fill' ) {
        $('.popup-subscribe').removeClass('is-active')
    }
});
